module.exports = __webpack_public_path__ + "img/icon 8@3x.da5bc964.png";